import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { StoreSearchState } from '../models/store.model';
import * as selectors from '../selectors/search.selectors';

@Injectable()
export class StoreSearchFacadeService extends FacadeService {
  constructor(public override store: Store<StoreSearchState>) {
    super(store);
  }

  sideNavOpened$ = this.storeSelect(selectors.getSideNavOpened);
  panelExpanded$ = this.storeSelect(selectors.getPanelExpansion);
  storeName$ = this.storeSelect(selectors.getStoreName);
  storeCode$ = this.storeSelect(selectors.getStoreCode);
  showInactiveStores$ = this.storeSelect(selectors.getShowInactiveStores);
  tableCanUpdate$ = this.storeSelect(selectors.getTableCanUpdate);
  canCreateStore$ = this.storeSelect(selectors.getCanCreateStore);

  get sideNavOpened() {
    return this.storeSnapshot(this.sideNavOpened$);
  }

  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get showInactiveStores() {
    return this.storeSnapshot(this.showInactiveStores$);
  }

  get storeCode() {
    return this.storeSnapshot(this.storeCode$);
  }

  get storeName() {
    return this.storeSnapshot(this.storeName$);
  }
}
